<figure class="previa" [class.previa--miniatura]="miniatura" *ngIf="captura">
  <div class="previa__navegacao" *ngIf="!miniatura && capturas.length > 1" role="group" aria-label="Capturas do recurso">
      <button type="button" aria-label="Captura anterior" [disabled]="indice === 0" (click)="indice = indice - 1">← Anterior</button>
      <span aria-live="polite">{{indice + 1}} de {{capturas.length}}</span>
      <button type="button" aria-label="Próxima captura" [disabled]="indice === capturas.length - 1" (click)="indice = indice + 1">Próxima →</button>
    </div>
  <img class="previa__imagem" [src]="captura.imagem" [alt]="captura.titulo" loading="lazy">
  <span class="previa__quantidade" *ngIf="miniatura && capturas.length > 1">{{capturas.length}} telas reais</span>
  <ng-container *ngIf="!miniatura">
    <figcaption aria-live="polite"><strong>{{captura.titulo}}</strong>{{captura.legenda}}</figcaption>
  </ng-container>
</figure>
